import * as Slider from "@radix-ui/react-slider"
import { useAtom } from "jotai"
import { useTranslation } from "react-i18next"
import { Button } from "./Button"
import { GridSize } from "@/store/undoable-state"
import { gridSizeAtom } from "@/store/photo/photos-view-state"

export const GridSizeSlider = () => {
	const { t } = useTranslation("components")
	const [gridSize, setGridSize] = useAtom(gridSizeAtom)

	const increaseSize = () => {
		if (gridSize && gridSize < 8) {
			setGridSize((gridSize + 1) as GridSize)
		}
	}

	const decreaseSize = () => {
		if (gridSize && gridSize > 3) {
			setGridSize((gridSize - 1) as GridSize)
		}
	}

	return (
		<div className="flex flex-row items-center justify-center space-x-0 align-middle">
			<Button
				trackingLabel="decrease_grid_size"
				aria-label={t("gridSizeSlider.ariaDecreaseGridThumbnailSize")}
				onClick={decreaseSize}
				variant="ghost"
				className="mb-0.5 flex text-md font-bold"
			>
				-
			</Button>
			<Slider.Root
				value={[gridSize ?? 5]}
				onValueChange={(value) => setGridSize(value[0] as GridSize)}
				defaultValue={[5]}
				min={3}
				max={8}
				step={1}
				aria-label={t("gridSizeSlider.ariaGridSize")}
				className="electron-no-drag relative flex h-3 w-[100px] touch-none items-center"
			>
				<Slider.Track className="relative h-1 w-full grow rounded-full bg-base-400">
					<Slider.Range className="absolute h-full rounded-full bg-base-300" />
				</Slider.Track>
				<Slider.Thumb className="block size-3 rounded-full bg-base-800 outline-none ring-1 ring-base-300" />
			</Slider.Root>
			<Button
				trackingLabel="increase_grid_size"
				aria-label={t("gridSizeSlider.ariaIncreaseGridThumbnailSize")}
				onClick={increaseSize}
				variant="ghost"
				className="mb-0.5 flex text-md font-bold"
			>
				+
			</Button>
		</div>
	)
}
